import { BASE } from "./constants";

export interface ReleaseFile {
  id: number;
  name: string;
  link: string;
}

export interface ReleaseOption {
  key: string;
  value: string;
}

export interface Release {
  name: string;
  files: ReleaseFile[];
  options: ReleaseOption[];
}

const addDownloadLinks = (releases: Release[]): Release[] =>
  releases.map((release) => {
    if (release.files && release.files.length > 0) {
      return {
        ...release,
        files: release.files.map((f) => ({
          ...f,
          link: `${BASE}/releases/${f.id}/download?save_as=${f.name}`,
        })),
      };
    }
    return { ...release, files: [] };
  });

let cachedRequest: Promise<Release[]> | null = null;

export const getReleases = (): Promise<Release[]> => {
  if (!cachedRequest) {
    cachedRequest = fetch(`${BASE}/releases?tag=latest&option=type:stable`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json() as Promise<Release[]>;
      })
      .then(addDownloadLinks)
      .catch((err) => {
        cachedRequest = null;
        throw err;
      });
  }
  return cachedRequest;
};
